const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

const LOCAL_TIMESTAMP = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/

// Timestamps without a time zone are read as UTC so the server and the browser always agree.
export const toDate = (value: string | null | undefined): Date | null => {
    if (!value) return null

    const trimmed = value.trim()
    const normalized = LOCAL_TIMESTAMP.test(trimmed) ? `${trimmed.replace(' ', 'T')}Z` : trimmed
    const date = new Date(normalized)

    return Number.isNaN(date.getTime()) ? null : date
}

export const toIsoDate = (value: string | null | undefined): string | null => {
    return toDate(value)?.toISOString() ?? null
}

export const formatDate = (value: string | null | undefined): string => {
    const date = toDate(value)

    if (!date) return ''

    return `${MONTHS[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`
}

export const getInitials = (name: string): string => {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('')
}

export const parsePageParam = (value: string | string[] | undefined): number => {
    const raw = Array.isArray(value) ? value[0] : value

    if (!raw || !/^\d+$/.test(raw)) return 1

    const page = Number(raw)

    return page >= 1 ? page : 1
}

export const readQueryParam = (value: string | string[] | undefined): string => {
    const raw = Array.isArray(value) ? value[0] : value

    return typeof raw === 'string' ? raw : ''
}

export const escapeXml = (value: string): string => {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;')
}

export const isNumericLabel = (value: string): boolean => /^\d+$/.test(value.trim())

export const countLabel = (count: number, singular: string, plural: string): string => {
    return `${count} ${count === 1 ? singular : plural}`
}
